import React, { PropTypes } from 'react';
import Pagination from 'react-js-pagination';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import Form from './../../components/search-form';
import InfluencerGrid from './../../components/influencer-grid';
import SortWidget from './../../components/sort-widget';
import ScrollTopButton from './../../components/scroll-top';
import Header from './../../components/header';
import Footer from './../../components/footer';

import * as Action from './actions';
import { influencerService } from './../../services/influencer-service';

class Search extends React.Component {

  static contextTypes = {
    router: PropTypes.object,
  }

  componentWillMount() {
    const { query } = this.props;
    if(!query){
      this.fetchTrending();
    }
  }

  componentDidMount() {
    this.formComponent = this.form;
  }

  // TODO: Do this properly as soon as possible
  paginate() {
    const { influencers, page, perPage } = this.props;
    const from = (parseInt(page, 0) === 1) ? 0 : (perPage * (page - 1));
    const take = from + perPage;
    return influencers.slice(from, take);
  }

  fetchTrending = async () => {
    const trending = await influencerService.getTrendingInfluencers();
    if(trending){
      this.props.loadTrending(trending.influencers);
    }
  };

  doSearch = async (e, q) => {
    if (e) e.preventDefault();

    const query = q || this.formComponent.queryInput.value;
    if (!query) return;

    this.props.loading(true);

    const result = await influencerService.getInfluencers({
      searchTerm: query,
    });

    if(result){
      this.props.search(query, result.influencers);
    }
  }

  categoryClickHandler(category) {
    if (!category){
      return;
    };
    this.formComponent.queryInput.value = category.label;
    this.doSearch(null, category.value);
  }

  paginationChangeHandler(page) {
    this.props.moveToPage(page);
    window.scrollTo(0, 0);
  }

  currentPageText(page, perPage, total) {
    const from = page === 1 ? 1 : (page - 1) * perPage;
    const to = page === 1 ? perPage : page * perPage;
    return (
      <div className='sort current'>
        Showing <b>{from}</b> - <b>{to < total ? to: total}</b> from <b>{total}</b> results
      </div>
    );
  }

  sort(order){
    const { influencers } = this.props;
    if(order.value === 'lowest'){
      influencers.sort((l, r) => l.totalSocialReach - r.totalSocialReach);
    } else {
      influencers.sort((l, r) => r.totalSocialReach - l.totalSocialReach);
    }
    this.props.sortResults(influencers, order);
  }

  render() {
    const {
      page,
      perPage,
      isLoading,
      showingTrending,
      influencers,
      query,
      order,
      searchPerformed,
    } = this.props;

    return (
        <section id="search">
          <Header />
          <Helmet
            title="Search"
          />
          {!showingTrending && influencers.length > 0 && <ScrollTopButton />}
          <Form
            ref={f => (this.form = f)}
            searchHandler={this.doSearch}
            categoryClickHandler={category => this.categoryClickHandler(category)}
          />
        <section className="content">
          {!showingTrending && !isLoading && searchPerformed && influencers.length != 0 && 
            <div className="control grid">
              <div className="grid-md-2-6 left text-md-center">
                {this.currentPageText(page, perPage, influencers.length)}
              </div>
              <div className="grid-md-2-6 center">
              { influencers.length > perPage &&
                <Pagination
                  activePage={page}
                  itemsCountPerPage={perPage}
                  totalItemsCount={influencers.length}
                  onChange={activePage => this.paginationChangeHandler(activePage)}
                />
              }
              </div>
              <div className="grid-md-2-6 right">
                <SortWidget selected={order} handle={order => this.sort(order)} />
              </div>
            </div>
          }
          <InfluencerGrid
            query={query}
            isLoading={isLoading}
            searchPerformed={searchPerformed}
            showingTrending={showingTrending}
            influencers={this.paginate(0, 24)}
          />

          { influencers.length > perPage &&
          <div className="text-center" id="pagination">
            <Pagination
              activePage={page}
              itemsCountPerPage={perPage}
              totalItemsCount={influencers.length}
              onChange={activePage => this.paginationChangeHandler(activePage)}
            />
          </div>
          }

        </section>
        <Footer />
        </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    influencers: state.search.get('influencers'),
    page: state.search.get('page'),
    perPage: state.search.get('perPage'),
    searchPerformed: state.search.get('searchPerformed'),
    query: state.search.get('query'),
    order: state.search.get('order'),
    isLoading: state.search.get('isLoading'),
    isError: state.search.get('isError'),
    errorMessage: state.search.get('errorMessage'),
    showingTrending: state.search.get('showingTrending')
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    loadTrending: (items) => dispatch(Action.loadTrending(items)),
    search: (query, items) => dispatch(Action.search(query, items)),
    loading: (isLoading) => dispatch(Action.loading(isLoading)),
    moveToPage: (page) => dispatch(Action.moveToPage(page)),
    sortResults: (items, order) => dispatch(Action.sortResults(items, order)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/containers/search/index.js